// extracted by mini-css-extract-plugin
module.exports = {"avatar":"avatar--2Mwbxc2q","xs-avatar":"xs-avatar--Kd4e5tJS","default-avatar":"default-avatar--2bSFnmZd"};